// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page {
   min-height: 100%;
   display: flex;
   align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/utility/ErrorPage/ErrorPage.css"],"names":[],"mappings":"AAAA;GACG,gBAAgB;GAChB,aAAa;GACb,mBAAmB;AACtB","sourcesContent":[".error-page {\r\n   min-height: 100%;\r\n   display: flex;\r\n   align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
